import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide
      notes="AI proeverij workshop introduction"
      transition="fade"
      visualizer="hidden"
      networkBackground="full"
    >
      <div className="relative z-10 flex flex-col items-center justify-center h-full">
        <h1 className="title">AI proeverij</h1>
        <p className="subtitle">Advanced Workflows Workshop</p>
        <p className="byline">Jonathan & EVA</p>
        <div className="mt-8 space-y-2 text-center">
          <p className="text-lg text-gray-400">N=5</p>
        </div>
      </div>
    </Slide>
  );
};
